import { isAttachFileWithoutCloudType } from 'reactApp/modules/attaches/attaches.helpers';

import type { UseOvidiusData, UseOvidiusProps } from './types';
import { useAttachOvidius } from './useAttachOvidius';
import { useHomeOvidius } from './useHomeOvidius';

export const useNormalizedOvidius = (params: UseOvidiusProps): UseOvidiusData => {
    const attachResult = useAttachOvidius(params);
    const homeResult = useHomeOvidius(params);

    return isAttachFileWithoutCloudType(params.file) ? attachResult : homeResult;
};
